<template>
  <div>
    <h4
      v-bind="attributesBinding"
      :class="mainExpression == 'Edit' ? 'text-center' : null"
    >
      <v-btn
        fab
        color="warning"
        v-if="
          currentField.file &&
          currentField.file.fileUrl &&
          mainExpression !== 'Edit'
        "
        width="25"
        height="25"
        class="mb-1"
      >
        <v-icon size="20" small>fas fa-volume-up</v-icon>
      </v-btn>
      <span
        :class="{
          'ml-1':
            currentField.file &&
            currentField.file.fileUrl &&
            mainExpression !== 'Edit',
        }"
        >{{
          currentField.value.ja ? currentField.value.ja : currentField.text
        }}</span
      >
    </h4>
    <p
      class="ma-0 text-caption"
      :class="{
        'ml-7':
          currentField.file &&
          currentField.file.fileUrl &&
          mainExpression !== 'Edit',
      }"
      v-if="mainExpression == 'Preview' && isLanguage !== 'ja'"
    >
      {{ captionText }}
    </p>
  </div>
</template>


<script>
export default {
  name: "FormElementExample",
  store: ["mainExpression", "isLanguage"],
  props: ["currentField"],
  computed: {
    attributesBinding() {
      var attr = {};
      if (this.currentField.id) {
        attr.id = `label-${this.currentField.id}`;
      }
      if (this.currentField.color) {
        attr.style = { color: this.currentField.color };
      }
      return attr;
    },
    captionText() {
      if (!this.currentField.value[this.isLanguage]) {
        return "";
      }
      return this.currentField.value[this.isLanguage];
    },
  },
};
</script>
<style scoped>
::v-deep .v-input__slot {
  min-height: 30px !important;
}
p {
  line-height: 1;
}
h4 {
  user-select: none;
  word-wrap: break-word;
  white-space: pre-line;
}
</style>
